import { TENANT_CONFIG } from '@config'

const host = window?.location?.host
const initiator = import.meta.env.DEV ? 'http' : 'https'
const redirectUri = `${initiator}://${host}/callback`

export const handleDiscordAuth = () => {
  const page = window?.location?.pathname
  const discordAuthUrl = `https://discord.com/api/oauth2/authorize?response_type=token&client_id=${TENANT_CONFIG.discordClientId}&scope=identify%20guilds.members.read&redirect_uri=${redirectUri}&state=${page}`

  window.open(discordAuthUrl, '_self')
}
